import { render, staticRenderFns } from "./PersonnelList.vue?vue&type=template&id=1970eb16&scoped=true&"
import script from "./PersonnelList.vue?vue&type=script&lang=ts&"
export * from "./PersonnelList.vue?vue&type=script&lang=ts&"
import style0 from "./PersonnelList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PersonnelList.vue?vue&type=style&index=1&id=1970eb16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970eb16",
  null
  
)

component.options.__file = "PersonnelList.vue"
export default component.exports